import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  collection,
  addDoc,
  doc,
  getDoc,
  docData,
} from '@angular/fire/firestore';
import { Document } from 'src/app/models/document';
import { from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private firestore: Firestore = inject(Firestore);

  postDocument(document: Document) {
    const collectionRef = collection(this.firestore, 'documents');
    return from(addDoc(collectionRef, document));
  }

  getDocumentById(id: string) {
    const docRef = doc(this.firestore, `documents/${id}`);
    return from(getDoc(docRef)).pipe(
      map((docSnap) => {
        const data = docSnap.data() as Document;
        data.id = docSnap.id;
        return data;
      })
    );
  }
}
